import { Injectable } from "@angular/core";
import { HttpErrorResponse } from "@angular/common/http";
import { NavigationStart, Router } from "@angular/router";
import { Observable, Subject } from "rxjs";

import * as _ from 'lodash';

@Injectable()
export class AlertService {
	private subject = new Subject<any>();
	private keepAfterNavigationChange = false;

	constructor(private _router: Router) {
		// clear alert message on route change
		_router.events.subscribe(event => {
			if (event instanceof NavigationStart) {
				if (this.keepAfterNavigationChange) {
					// only keep for a single location change
					this.keepAfterNavigationChange = false;
				} else {
					// clear alert
					this.subject.next(undefined);
				}
			}
		});
	}

	public success(message: string, keepAfterNavigationChange = false) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;

		this.subject.next({
			type: 'success',
			text: message
		});
	}
	public errorMessage(message: string, keepAfterNavigationChange = false) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;

		this.subject.next({
			type: 'danger',
			text: message
		});
	}

	// error(message: string, keepAfterNavigationChange = false) {
	// 	this.keepAfterNavigationChange = keepAfterNavigationChange;
	// 	this.subject.next({ type: 'danger', text: message });
	// }

	public error(error: HttpErrorResponse, keepAfterNavigationChange = false) {
		this.keepAfterNavigationChange = keepAfterNavigationChange;

		this.subject.next({
			type: 'danger',
			text: this.getTextFromError(error)
		});
	}

	private getTextFromError(error: HttpErrorResponse): string {
		switch (error.status) {
			case 500:
				return this.errorText(error, 'Internal Server Error');
			case 501:
				return 'Not Implemented';
			case 502:
				return 'Bad Gateway';
			case 503:
				return 'Service Unavailable';
			case 400:
				return this.errorText(error, 'Bad Request');
			case 401:
				return 'Invalid Username Or Password';
			case 403:
				return 'Access Forbidden';
			case 404:
				return 'Not Found';
			case 0:
				return 'API Error';
			default:
				return this.errorText(error, 'Unknown Error');
		}
	}

	private errorText(error: any, text: string = ''): string {
		if (_.isEmpty(error)) {
			return text;
		}
		if (!_.isEmpty(error.statusText)) {
			return error.statusText;
		}
		if (!_.isEmpty(error.error)) {
			return this.errorText(error.error, text);
		}
		return error.message || text;
	}

	getMessage(): Observable<any> {
		return this.subject.asObservable();
	}
}


